import { useEffect, useRef } from 'react';

export function useAppTitle({
  loggedIn,
  roomId,
  roomStats,
  periodMs = 5000,
  baseTitle,
}) {
  // Basis-Titel einmal merken
  const baseRef = useRef(baseTitle ?? document.title);

  useEffect(() => {
    const base = baseRef.current;

    const update = () => {
      const unread = Number(roomStats?.messageStats?.messagesUnreaded ?? 0);

      if (!loggedIn) {
        document.title = `Logged out — ${base}`;
        return;
      }

      if (!roomId) {
        document.title = `No chat selected — ${base}`;
        return;
      }

      if (unread > 0) {
        document.title = `Unread messages ${unread} — ${base}`;
        return;
      }

      // Chat ist ausgewählt, aber keine ungelesenen Nachrichten
      document.title = `${base}`;
    };

    update(); // sofort ausführen
    const id = setInterval(update, periodMs);
    return () => {
      clearInterval(id);
      document.title = base; // aufräumen
    };
  }, [loggedIn, roomId, roomStats, periodMs]);
}
